module.exports = __webpack_public_path__ + "img/slider-image-01-isanon.07316449.png";